import { createClient } from 'services/clientConfiguration';

const BASE_URL = '/api/platform-admin/v1/';

const http = createClient({
  baseURL: BASE_URL,
});

export const getMacroRoles = (macroName = '') => {
  const url = `macroroles/${macroName}/retrieve`;
  return http.get(url);
};

export const getRoles = (params = '') => {
  const url = `roles/search${params}`;
  return http.get(url);
};
